/* MIXINS POUR LES AVIS (REVIEWS) */
export default {
  methods: {
    colorRating(review) {
      if (!review.reservationSite) return 'text-grey-400';
      let site = review.reservationSite.toLowerCase();
      let rating = 0;
      if (site.includes('vrbo') || site.includes('booking') || site.includes('homeaway')) {
        rating = review.ratingTen;
        if (rating <= 6) {
          return 'text-red';
        } else if (rating <= 8) {
          return 'text-tertiary';
        }
        return 'text-green';
      } else if (
        site.includes('airbnb') ||
        site.includes('pap') ||
        site.includes('holidu') ||
        site.includes('hometogo') ||
        site.includes('office') ||
        site.includes('guest-adom') ||
        site.includes('guestadom')
      ) {
        rating = review.rating;
        if (rating <= 4) {
          return 'text-red';
        } else if (rating <= 4.6) {
          return 'text-tertiary';
        }
        return 'text-green';
      }
      return 'text-grey-400';
    },
    colorRatingWithRating(s, rating) {
      if (!s) return 'text-grey-400';
      let site = s.toLowerCase();
      if (site.includes('vrbo') || site.includes('booking') || site.includes('homeaway') || site.includes('global')) {
        if (rating <= 6) {
          return 'text-red';
        } else if (rating <= 8) {
          return 'text-tertiary';
        }
        return 'text-green';
      } else if (
        site.includes('airbnb') ||
        site.includes('pap') ||
        site.includes('holidu') ||
        site.includes('hometogo') ||
        site.includes('office') ||
        site.includes('guest-adom') ||
        site.includes('guestadom')
      ) {
        if (rating <= 4) {
          return 'text-red';
        } else if (rating <= 4.6) {
          return 'text-tertiary';
        }
        return 'text-green';
      }
      return 'text-grey-400';
    },

    colorCriteraRating(rating) {
      if (!rating) return 'text-grey-400 opacity-50';
      if (rating <= 2) return 'text-red';
      if (rating >= 4) return 'text-green';
      return 'text-grey-400';
    },
    scaleRating(site) {
      if (!site) return '10';
      let siteLower = site.toLowerCase();

      if (siteLower.includes('vrbo')) return '10';
      if (siteLower.includes('airbnb')) return '5';
      if (siteLower.includes('pap')) return '5';
      if (siteLower.includes('holidu')) return '5';
      if (siteLower.includes('hometogo')) return '5';
      if (siteLower.includes('office')) return '5';
      if (siteLower.includes('booking')) return '10';
      if (siteLower.includes('homeaway')) return '10';
      if (siteLower.includes('guest-adom')) return '5';
      if (siteLower.includes('guestadom')) return '5';
      return '10';
    },
    rating(review) {
      if (!review.reservationSite) return review.ratingTen;
      let siteLower = review.reservationSite.toLowerCase();

      if (siteLower.includes('vrbo')) return review.ratingTen;
      if (siteLower.includes('airbnb')) return review.rating;
      if (siteLower.includes('pap')) return review.rating;
      if (siteLower.includes('holidu')) return review.rating;
      if (siteLower.includes('hometogo')) return review.rating;
      if (siteLower.includes('office')) return review.rating;
      if (siteLower.includes('booking')) return review.ratingTen;
      if (siteLower.includes('homeaway')) return review.ratingTen;
      if (siteLower.includes('guest-adom')) return review.rating;
      if (siteLower.includes('guestadom')) return review.rating;
      return review.ratingTen;
    },
  },
};
